'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialRedditOutline = function IoSocialRedditOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.7 22.5c0-1.6 0.9-2.4 2.5-2.4s2.5 0.8 2.5 2.4-0.8 2.5-2.5 2.5-2.5-0.9-2.5-2.5z m-10.3 0c0-1.6 0.9-2.4 2.5-2.4s2.5 0.8 2.5 2.4-0.8 2.5-2.5 2.5-2.5-0.9-2.5-2.5z m25.2-2.9c0 1.6-0.7 2.8-2.1 3.5 0 0.4 0 0.7 0 1.1 0 3-1.4 5.6-4.5 7.7s-6.6 3.1-10.9 3.1-8-1-11-3.1-4.6-4.6-4.6-7.6c0-0.4 0-0.8 0.1-1.2-1.4-0.7-2.1-1.8-2.1-3.5 0-1.1 0.4-1.9 1.2-2.7s1.6-1.2 2.7-1.2c1 0 1.9 0.3 2.6 1 2.8-1.9 6.2-3 10.1-3.2h0.5l2.3-7.6 6.7 1.3c0.6-1.5 1.6-2.2 3.2-2.2 0.9 0 1.7 0.3 2.4 1s1 1.6 1 2.5-0.3 1.8-1 2.5-1.5 1-2.4 1-1.8-0.3-2.5-1-1-1.5-1-2.4l-5.4-1.1-1.9 6c3.9 0.2 7.4 1.3 10.1 3.2 0.8-0.7 1.6-1 2.6-1 0.8 0 1.3 0.2 1.9 0.5s1.1 0.8 1.4 1.5 0.6 1.2 0.6 1.9z m-5.8-13.2c-0.3 0-0.6 0.1-0.9 0.2s-0.4 0.3-0.6 0.4-0.4 0.5-0.5 0.7-0.1 0.5-0.1 0.8c0 0.6 0.2 1.1 0.6 1.5s1 0.6 1.5 0.6c0.4 0 0.7-0.1 1-0.2s0.6-0.5 0.8-0.8 0.3-0.7 0.3-1.1c0-0.6-0.2-1.1-0.6-1.5s-1-0.6-1.5-0.6z m-27.9 13.2c0 0.9 0.4 1.6 1.1 2.1 0.5-1.5 1.5-2.9 2.9-4.1-0.5-0.3-0.9-0.5-1.5-0.5-0.2 0-0.5 0-0.8 0.1s-0.4 0.2-0.7 0.4-0.4 0.3-0.5 0.5-0.3 0.5-0.4 0.7-0.1 0.5-0.1 0.8z m26.3 11.1c2.7-1.8 3.9-4 3.9-6.5v-0.7c0-0.5-0.2-0.9-0.4-1.4-0.4-1.2-1.1-2.3-2.3-3.4-0.4-0.3-0.8-0.7-1.2-0.9-2.8-1.9-6.1-2.9-10.1-2.9s-7.4 1-10.3 2.9c-0.3 0.2-0.7 0.6-1.1 1-1.2 1-1.9 2.1-2.4 3.3-0.1 0.5-0.3 0.9-0.4 1.4v0.7c0 2.5 1.3 4.7 3.9 6.5 2.9 2 6.3 2.9 10.3 2.9s7.3-0.9 10.1-2.9z m4.9-9c0.7-0.5 1.1-1.2 1.1-2.1 0-0.7-0.3-1.3-0.7-1.8s-1-0.7-1.8-0.7c-0.5 0-1 0.2-1.5 0.5 1.4 1.2 2.3 2.6 2.9 4.1z m-10 6.3l1 0.9c-1.6 1.6-3.5 2.4-6 2.4s-4.6-0.8-6.1-2.4l1-0.9c1.2 1.2 3 1.8 5.1 1.8s3.7-0.6 5-1.8z' })
        )
    );
};

exports.default = IoSocialRedditOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-reddit-outline.js
// module id = 2493
// module chunks = 0